<button adaptButtonIcon="add"
        class="mb-3"
        [adaptBlockingClick]="addNewCoach">Add a coach</button>

<dx-data-grid [dataSource]="connections"
              [allowColumnReordering]="true"
              [allowColumnResizing]="true"
              [columnAutoWidth]="true"
              [rowAlternationEnabled]="true">
    <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
    <dxo-data-grid-header-filter [visible]="true"></dxo-data-grid-header-filter>

    <dxi-data-grid-column dataField="person.fullName"
                          dataType="string"
                          caption="Coach"
                          cellTemplate="coachNameLinkCellTemplate"></dxi-data-grid-column>
    <dxi-data-grid-column dataField="startDate"
                          dataType="date"
                          caption="Start Date"
                          [format]="dateFormat"></dxi-data-grid-column>
    <dxi-data-grid-column dataField="endDate"
                          dataType="date"
                          caption="End Date"
                          [format]="dateFormat"></dxi-data-grid-column>
    <dxi-data-grid-column caption="Coach Roles"
                          dataField="dummy_coachRoles"
                          dataType="string"
                          cellTemplate="rolesCellTemplate"
                          [allowFiltering]="true"
                          [calculateCellValue]="calculateRolesCellValue"></dxi-data-grid-column>
    <dxi-data-grid-column caption="Status"
                          dataType="boolean"
                          [allowFiltering]="true"
                          [calculateCellValue]="calculateActiveCellValue"
                          trueText="Active"
                          falseText="Inactive"
                          [filterValue]="true"></dxi-data-grid-column>
    <dxi-data-grid-column caption="Actions"
                          cellTemplate="actionsCellTemplate"></dxi-data-grid-column>

    <div *dxTemplate="let data of 'coachNameLinkCellTemplate'">
        <adapt-link-person [person]="data.data.person"></adapt-link-person>
    </div>

    <div *dxTemplate="let data of 'rolesCellTemplate'">
        <ul>
            @for (roleConnection of data.data.roleConnections; track roleConnection.roleConnectionId) {
                @if (roleConnection.role && roleConnection.isActive()) {
                    <li>{{ roleConnection.role.label }}</li>
                }
            }
        </ul>
    </div>

    <div *dxTemplate="let data of 'actionsCellTemplate'">
        <div>
            <button adaptButton="edit"
                    (click)="editPractitionerConnection(data.data)"></button>
            @if (!data.data.endDate) {
                <button adaptButton="end"
                        (click)="endCoachConnection(data.data)"></button>
            }
            <button adaptButton="delete"
                    (click)="deletePractitionerConnection(data.data)"></button>
        </div>
    </div>
</dx-data-grid>
